export default __webpack_public_path__ + "media/zurb/img/work/wtsbooks/wtsbooks-logos-bfbca603451983d230a39f33ca5bb6fa.png";